import React from "react";
import { Sparkles } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const SabbatBadge = ({ sabbat, testid, className = "" }) => {
  const { t } = useLang();
  if (!sabbat) return null;
  return (
    <span
      data-testid={testid}
      title={t("ev_sabbat_label")}
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-mono tracking-wider uppercase bg-indigo-950/70 backdrop-blur text-indigo-200 border border-indigo-600/50 ${className}`}
    >
      <Sparkles className="w-3.5 h-3.5" /> {t(`sabbat_${sabbat}`)}
    </span>
  );
};

export default SabbatBadge;
